import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import {
  useNavigate,
  Link,
} from "react-router-dom";
import {
  auth,
  existsUsername,
  getUserInfo,
  updateUser,
  userExists,
} from "../firebase/firebase";
import Loading from "../components/loading";
import "./usernameview.css";

/*
  Stages:
  0: initiated
  1: loading
  2: login completed
  3: login but no username
  4: not logged
  5: username exists
  6: username correct
*/
export default function UsernameView() {
  const [currentUser, setCurrentUser] = useState(null);
  const [state, setState] = useState(0);
  let navigate = useNavigate();

  useEffect(() => {
    setState(1);
    onAuthStateChanged(auth, callBackAuthState);
  }, []);

  async function callBackAuthState(user) {
    if (user) {
      const uid = user.uid;
      if (userExists(user.uid)) {
        const loggedUser = await getUserInfo(uid);
        setCurrentUser(loggedUser);
        if (!loggedUser.processCompleted) {
          setState(3);
        } else {
          navigate("/dashboard");
        }
      } else {
        navigate("/login");
      }
    } else {
      navigate("/login");
    }
  }

  function handleInputUsername(e) {
    const tmpUser = currentUser;
    const value = e.target.value.toLowerCase(); // Convertir el valor a minúsculas
    tmpUser.username = value;
    setCurrentUser({ ...tmpUser });
  }

  async function handleOnClickContinue() {
    if (currentUser.username !== "") {
      const exists = await existsUsername(currentUser.username);
      if (exists) {
        setState(5);
      } else {
        currentUser.processCompleted = true;
        await updateUser(currentUser);
        setState(6);
      }
    }
  }

  if (state === 6) {
    return (
      <div className="centered-container">
        <h1 className="ht">¡Felicidades! ahora puedes ir al dashboard</h1>
        <Link className="conbt" to="/dashboard">Continuar</Link>
      </div>
    );
  }

  if (state === 3) {
    return (
      <div className="con">
        <h1>Bienvenido {currentUser?.displayName}, te falta un username</h1>
        <div>
          <input type="text" onInput={handleInputUsername} placeholder="Ingrese un username" />
        </div>
        <div>
          <button className="btnj" onClick={handleOnClickContinue}>Continuar</button>
        </div>
      </div>
    );
  }

  return <Loading />;
}
